import { Lv } from '../i18n/L';   // V160 표시용 라벨 중국어
// ── 세무 신고 도우미 V1 — 상수/매핑 ─────────────────────────────────────────
// PRD: PRD_tax_helper_v1.md 참고
// 거래(Transaction) / 거래처(Partner) / 기간(TaxPeriod) 관련 상수

// ── 카테고리 (대분류 5개 ↔ 소분류 종소세 표준 23개) ──────────────────────────
// 대분류는 자영업자에게 보이는 단순한 5개. 소분류는 종소세 신고서 항목.
// 출력 시 자동 매핑.

export const CATEGORY_MAJOR = [
  { id: 'material',  label: '재료비',     emoji: '🥬', color: '#18181B' },
  { id: 'operation', label: '운영비',     emoji: '🏪', color: '#3b82f6' },
  { id: 'labor',     label: '인건비',     emoji: '👥', color: '#A1A1AA' },
  { id: 'marketing', label: '광고·접대',  emoji: '📢', color: '#ec4899' },
  { id: 'etc',       label: '기타',       emoji: '📋', color: '#6b7280' },
];

// 소분류 — 종소세 표준 경비 항목 (필요경비) + 매출 카테고리
export const CATEGORY_SUB = {
  material: [
    { id: 'raw_material',    label: '원재료비' },         // 음식점 식자재 등
    { id: 'merchandise',     label: '상품매입' },         // 도소매 매입원가
    { id: 'subcontract',     label: '외주가공비' },
    { id: 'packaging',       label: '포장비' },
  ],
  operation: [
    { id: 'rent',            label: '임차료' },
    { id: 'utilities',       label: '수도광열비' },        // 전기, 수도, 가스
    { id: 'communication',   label: '통신비' },
    { id: 'supplies',        label: '소모품비' },
    { id: 'fees',            label: '지급수수료' },        // 카드수수료, 배달수수료 등
    { id: 'maintenance',     label: '수선비' },
    { id: 'vehicle',         label: '차량유지비' },
    { id: 'taxes_dues',      label: '세금과공과' },        // 면허세, 자동차세 등
    { id: 'depreciation',    label: '감가상각비' },
  ],
  labor: [
    { id: 'salary',          label: '급여' },
    { id: 'social_insurance',label: '4대보험(사업자부담)' },
    { id: 'welfare',         label: '복리후생비' },
  ],
  marketing: [
    { id: 'advertising',     label: '광고선전비' },
    { id: 'entertainment',   label: '접대비' },           // 매입세액공제 X
    { id: 'travel',          label: '여비교통비' },
  ],
  etc: [
    { id: 'misc',            label: '잡비' },
    { id: 'books',           label: '도서인쇄비' },
    { id: 'training',        label: '교육훈련비' },
    { id: 'donation',        label: '기부금' },
  ],
};

// 매출 카테고리 (별도)
export const REVENUE_CATEGORIES = [
  { id: 'sales',         label: '매출 (현장)',    desc: '대면 판매·서비스' },
  { id: 'sales_card',    label: '매출 (카드)',    desc: '카드 결제' },
  { id: 'sales_cash',    label: '매출 (현금)',    desc: '현금 결제' },
  { id: 'sales_delivery',label: '매출 (배달앱)',  desc: '배민·요기요·쿠팡 등' },
  { id: 'sales_online',  label: '매출 (온라인)',  desc: '자체몰·스마트스토어 등' },
  { id: 'sales_other',   label: '매출 (기타)',    desc: '기타 수입' },
];

// ── 증빙 종류 ──────────────────────────────────────────────────────────────
export const EVIDENCE_TYPES = [
  { id: 'tax_invoice',   label: '세금계산서',           qualified: true,  desc: '전자/종이 세금계산서' },
  { id: 'card',          label: '카드매출전표',         qualified: true,  desc: '신용카드/체크카드' },
  { id: 'cash_receipt',  label: '현금영수증',           qualified: true,  desc: '사업자번호 등록 현금영수증' },
  { id: 'simple_receipt',label: '간이영수증',           qualified: false, desc: '3만원 이하만 인정 (가산세 위험)' },
  { id: 'paper_receipt', label: '일반영수증',           qualified: false, desc: '비적격증빙 (가산세 2%)' },
  { id: 'none',          label: '무증빙',               qualified: false, desc: '증빙 없음' },
];

// ── 사업자 유형 ────────────────────────────────────────────────────────────
export const BIZ_TYPES = [
  { id: 'general',    label: '일반과세자',    desc: '연 매출 1억400만원 이상' },
  { id: 'simplified', label: '간이과세자',    desc: '연 매출 1억400만원 미만' },
  { id: 'tax_exempt', label: '면세사업자',    desc: '병원·학원·농수산물 등' },
  { id: 'farmer',     label: '농어민',        desc: '의제매입공제 대상' },
  { id: 'individual', label: '개인',          desc: '비사업자' },
];

// ── 거래 타입 ──────────────────────────────────────────────────────────────
export const TRANSACTION_TYPES = [
  { id: 'income',  label: '매출' },
  { id: 'expense', label: '매입' },
];

// ── 입력 출처 ──────────────────────────────────────────────────────────────
export const TXN_SOURCES = [
  { id: 'manual',   label: '수동 입력' },
  { id: 'ocr',      label: 'OCR 영수증' },
  { id: 'popbill',  label: '팝빌(세금계산서)' },
  { id: 'card_api', label: '카드사 API' },
  { id: 'hometax',  label: '홈택스' },
  { id: 'pos',      label: 'POS' },
];

// ── 부가세율 ───────────────────────────────────────────────────────────────
export const VAT_RATE = 0.1; // 10%

// 공급가액 / 부가세 분리 계산
// total = supply + vat;  supply = total / 1.1;  vat = total * 0.1 / 1.1
export function splitVAT(total) {
  const t = Number(total) || 0;
  const supply = Math.round(t / 1.1);
  const vat = t - supply;
  return { supply, vat };
}
export function joinVAT(supply, vat) {
  return Math.round((Number(supply) || 0) + (Number(vat) || 0));
}

// ── 적격증빙 자동 판정 ──────────────────────────────────────────────────────
export function isQualifiedEvidence(evidenceType) {
  const e = EVIDENCE_TYPES.find(x => x.id === evidenceType);
  return e ? e.qualified : false;
}

// ── 매입세액공제 가능 여부 (간이 판정) ──────────────────────────────────────
// V1.5에서 더 정교화. 일단 단순 룰.
export function isVATDeductible(transaction) {
  if (transaction.type !== 'expense') return false;
  if (!transaction.evidence?.isQualified) return false;
  if (transaction.income?.isPersonal) return false;
  // 접대비는 매입세액공제 X
  if (transaction.category?.sub === 'entertainment') return false;
  return true;
}

// ── 의제매입공제 대상 후보 (V1.5) ────────────────────────────────────────
// 매입 거래의 품목명 + 거래처명 + 거래처 사업자유형 조합으로 자동 판정.
// 신뢰도 점수 반환 → UI에서 자동 마킹 vs 사용자 확인 분기.

// 면세 농축수산물 — 1차 가공 미만 (생물·신선·냉동 가능)
export const PRESUMED_KEYWORDS = {
  // 곡류
  grain: ['쌀', '잡곡', '현미', '백미', '찹쌀', '보리', '귀리', '밀', '메밀', '콩', '팥', '녹두', '수수', '조'],
  // 채소
  vegetable: ['배추', '무', '양배추', '시금치', '상추', '깻잎', '쑥갓', '미나리', '대파', '쪽파', '양파', '마늘', '생강', '고추', '풋고추', '청양고추', '피망', '파프리카', '오이', '호박', '애호박', '단호박', '가지', '토마토', '당근', '감자', '고구마', '연근', '우엉', '도라지', '더덕', '죽순', '마', '비트', '브로콜리', '콜리플라워', '아스파라거스', '셀러리', '케일', '루꼴라', '청경채', '얼갈이', '열무', '얼갈이배추', '청양', '야채', '채소'],
  // 버섯
  mushroom: ['버섯', '표고', '느타리', '팽이', '새송이', '양송이', '목이', '송이'],
  // 과일
  fruit: ['사과', '배', '귤', '오렌지', '레몬', '자몽', '한라봉', '천혜향', '딸기', '포도', '청포도', '거봉', '복숭아', '천도복숭아', '자두', '체리', '수박', '참외', '메론', '망고', '파인애플', '키위', '바나나', '블루베리', '라즈베리', '앵두', '대추', '감', '단감', '홍시', '곶감', '석류', '무화과', '과일'],
  // 축산물 (1차)
  meat: ['소고기', '한우', '쇠고기', '돼지고기', '한돈', '삼겹살', '목살', '항정살', '갈비', '등심', '안심', '채끝', '치마살', '갈매기살', '뽈살', '꽃등심', '닭', '닭고기', '닭가슴살', '닭다리', '닭날개', '오리', '오리고기', '오리훈제', '양고기', '염소', '메추리', '꿩'],
  // 수산물
  seafood: ['고등어', '갈치', '삼치', '꽁치', '청어', '명태', '대구', '도미', '광어', '우럭', '농어', '연어', '참치', '방어', '전갱이', '병어', '조기', '굴비', '가자미', '서대', '아귀', '메기', '장어', '뱀장어', '미꾸라지', '잉어', '붕어', '오징어', '낙지', '문어', '주꾸미', '갑오징어', '한치', '꼴뚜기', '새우', '대하', '꽃게', '대게', '킹크랩', '랍스터', '바닷가재', '게', '굴', '홍합', '바지락', '백합', '대합', '재첩', '소라', '전복', '해삼', '멍게', '미더덕', '성게', '해파리', '미역', '다시마', '김', '파래', '톳', '청각', '매생이', '곰피', '꼬시래기'],
  // 알·유
  egg_dairy: ['계란', '달걀', '오리알', '메추리알', '우유', '생우유', '원유'],
  // 소금·간장 등 (제한적)
  salt: ['천일염', '소금', '굵은소금', '꽃소금'],
};

// 모든 키워드를 평면 배열로
export const PRESUMED_DEDUCTION_KEYWORDS = Object.values(PRESUMED_KEYWORDS).flat();

// 가공식품 negative — 이게 들어가면 면세 아님
export const NON_PRESUMED_KEYWORDS = [
  '가공', '훈제', '양념', '조미', '소스', '드레싱', '양념장', '국물', '육수', '진공',
  '냉동만두', '만두', '돈까스', '치킨너겟', '햄', '소시지', '베이컨', '햄버거패티',
  '어묵', '맛살', '게맛살', '훈제연어',
  '통조림', '캔', '병조림',
  '라면', '국수', '파스타', '면',
  '빵', '도넛', '케이크', '쿠키', '과자', '스낵', '초콜릿', '사탕',
  '아이스크림', '요거트', '치즈', '버터', '크림',
  '두부', '콩나물(완)',  // 두부는 가공
  '음료', '주스', '커피', '차', '맥주', '소주', '와인', '주류',
  '식품', '완제품', '도시락', '반찬',
];

// 거래처명 hint — 이런 곳에서 사면 면세 가능성 ↑
export const PRESUMED_PARTNER_HINTS = [
  '농협', '하나로마트', '하나로', '농산물', '청과', '청과물',
  '정육점', '정육', '축산',
  '수산', '수협', '어시장', '횟집(도매)',
  '농장', '직거래', '산지',
  '도매시장', '가락', '강서농산물',
  '식자재', '식자재마트',
  '농어민',
];

/**
 * 의제매입공제 후보 자동 판정
 * @returns {{candidate: boolean, confidence: number, reason: string}}
 *   confidence: 0~1, 0.9 이상이면 자동 마킹, 미만이면 사용자 확인
 */
export function evaluatePresumedDeduction({ itemName, partnerName, bizType, evidenceType } = {}) {
  const item = String(itemName || '').toLowerCase();
  const partner = String(partnerName || '').toLowerCase();

  // 적격증빙 아니면 의제매입공제 신청 자체 어려움 (간이영수증·무증빙은 X)
  // 단, 농어민 직거래는 영수증 없어도 가능 — 별도 처리.
  const qualifiedEvidence = evidenceType === 'tax_invoice'
                         || evidenceType === 'card'
                         || evidenceType === 'cash_receipt';
  const farmerDirect = bizType === 'farmer';

  if (!qualifiedEvidence && !farmerDirect) {
    return { candidate: false, confidence: 0, reason: '비적격증빙' };
  }

  // 1차 가공품 negative 매칭
  const nonHit = NON_PRESUMED_KEYWORDS.find(k => item.includes(k.toLowerCase()));
  if (nonHit) {
    return { candidate: false, confidence: 0.95, reason: `가공식품 (${nonHit})` };
  }

  // 면세 키워드 매칭
  const keywordHit = PRESUMED_DEDUCTION_KEYWORDS.find(k => item.includes(k.toLowerCase()));

  // 거래처 hint
  const partnerHit = PRESUMED_PARTNER_HINTS.find(h => partner.includes(h.toLowerCase()));

  // 농어민 직거래
  if (farmerDirect) {
    return { candidate: true, confidence: 0.95, reason: '농어민 직거래' };
  }

  // 면세사업자 거래처면 +
  if (bizType === 'tax_exempt') {
    if (keywordHit || partnerHit) {
      return { candidate: true, confidence: 0.92, reason: `면세사업자 + ${keywordHit || partnerHit}` };
    }
    return { candidate: true, confidence: 0.7, reason: '면세사업자 거래처' };
  }

  // 키워드 + 거래처 hint 둘 다 → 매우 확신
  if (keywordHit && partnerHit) {
    return { candidate: true, confidence: 0.95, reason: `${keywordHit} (${partnerHit})` };
  }

  // 키워드만 → 확신
  if (keywordHit) {
    return { candidate: true, confidence: 0.85, reason: keywordHit };
  }

  // 거래처 hint만 → 사용자 확인 필요
  if (partnerHit) {
    return { candidate: true, confidence: 0.6, reason: `거래처 hint (${partnerHit})` };
  }

  return { candidate: false, confidence: 0, reason: null };
}

// 단순 boolean 헬퍼 (V1 호환)
export function isPresumedDeductionCandidate(itemName, partnerName, bizType, evidenceType) {
  return evaluatePresumedDeduction({ itemName, partnerName, bizType, evidenceType }).candidate;
}

// ── 의제매입공제율 자동 결정 ────────────────────────────────────────────────
// 음식점업 일반/개인 / 제조업 / 기타 등에 따라 다름.
// 음식점업: 일반과세자 8/108, 연 매출 4억 이하 개인 음식점 9/109
// 제조업: 6/106 또는 4/104 (중소기업 여부)
// 일단 음식점업 기준 기본값.

export const PRESUMED_RATES = {
  RESTAURANT_INDIVIDUAL_SMALL: { numerator: 9, denominator: 109, label: '9/109 (연 매출 4억 이하 개인 음식점)' },
  RESTAURANT_GENERAL:          { numerator: 8, denominator: 108, label: '8/108 (일반)' },
  MANUFACTURING:               { numerator: 6, denominator: 106, label: '6/106 (제조업)' },
};

/**
 * 의제매입공제율 결정
 * @param {object} ctx { industry, annualRevenue (원) }
 */
export function pickPresumedRate({ industry = 'food', annualRevenue = null } = {}) {
  // 매출 모르면 보수적으로 8/108
  if (annualRevenue === null || annualRevenue === undefined) return PRESUMED_RATES.RESTAURANT_GENERAL;
  // 4억 이하 개인 음식점
  if (annualRevenue <= 400_000_000 && (industry === 'food' || industry === 'restaurant')) {
    return PRESUMED_RATES.RESTAURANT_INDIVIDUAL_SMALL;
  }
  if (industry === 'manufacturing') return PRESUMED_RATES.MANUFACTURING;
  return PRESUMED_RATES.RESTAURANT_GENERAL;
}

export function calcPresumedDeduction(presumedSupply, rate) {
  const r = rate || PRESUMED_RATES.RESTAURANT_GENERAL;
  return Math.round((Number(presumedSupply) || 0) * r.numerator / r.denominator);
}

// ── 의제매입공제 한도 ──────────────────────────────────────────────────────
// 음식점업: 매출의 일정 비율 한도. 정확한 한도는 업종/규모/연도에 따라 다름.
// 2024년 기준:
//   음식점업 일반: 매출 4억 이하 65%, 4억 초과 50% / (개인은 75% / 65%)
//   기타: 매출의 50%
// 단순화: 개인 음식점 75% (4억 이하), 50% (그 외)

export function calcPresumedLimit({ industry = 'food', annualRevenue = null } = {}) {
  if (annualRevenue === null || annualRevenue === undefined) return null; // 한도 미상
  if (industry === 'food' || industry === 'restaurant') {
    if (annualRevenue <= 400_000_000) return Math.round(annualRevenue * 0.75);
    return Math.round(annualRevenue * 0.65);
  }
  return Math.round(annualRevenue * 0.5);
}

/**
 * 한도 안전도 평가
 * @returns {{status: 'unknown'|'safe'|'warning'|'over', taken, limit, ratio}}
 */
export function evaluatePresumedLimit({ presumedSupply, annualRevenue, industry = 'food' }) {
  const limit = calcPresumedLimit({ industry, annualRevenue });
  const taken = Number(presumedSupply) || 0;
  if (limit === null) return { status: 'unknown', taken, limit: null, ratio: null };
  const ratio = limit > 0 ? taken / limit : 0;
  if (ratio > 1) return { status: 'over', taken, limit, ratio };
  if (ratio > 0.85) return { status: 'warning', taken, limit, ratio };
  return { status: 'safe', taken, limit, ratio };
}

// ── 거래 객체 헬퍼 (기본값 생성) ────────────────────────────────────────────
/**
 * 새 거래 객체 빈 템플릿
 * @param {'income'|'expense'} type
 */
export function newTransaction(type = 'expense') {
  return {
    type,                          // 'income' | 'expense'
    date: new Date().toISOString().slice(0, 10),  // YYYY-MM-DD
    supply: 0,                     // 공급가액
    vat: 0,                        // 부가세
    total: 0,                      // 합계
    partnerId: null,
    partnerName: '',               // 거래처 자동완성용 (Partner 분리 전 임시)
    evidence: {
      type: 'card',
      isQualified: true,           // EVIDENCE_TYPES에서 자동
      sourceUrl: null,
      externalId: null,
    },
    category: {
      major: type === 'income' ? null : 'material',
      sub: null,
    },
    revenueCategory: type === 'income' ? 'sales_card' : null,
    itemName: '',
    memo: '',
    vatTreatment: {
      deductible: type === 'expense',
      presumed: false,             // 의제매입대상 (V1.5에서 자동)
      presumedRate: null,
      nonDeductibleReason: null,
    },
    incomeTreatment: {
      isBusinessExpense: true,     // 기본값 "사업"
      isPersonal: false,
      accountCode: null,
    },
    // ddabak 차별화 — 점진적 enrichment (V1에선 옵션, V2에서 자동 매칭)
    projectId: null,
    recipeId: null,
    menuId: null,
    // 영수증 분할 — 한 영수증이 여러 거래로 쪼개진 경우 같은 ID 공유
    sourceReceiptId: null,           // UUID — 같은 영수증에서 분할된 거래는 같은 값
    splitInfo: null,                 // { totalReceiptAmount, splitIndex, splitTotal } 분할일 때만
    // 시스템
    source: 'manual',
    needsReview: false,
    confidence: null,
    createdAt: null,
    updatedAt: null,
  };
}

// ── 영수증 분할 헬퍼 ───────────────────────────────────────────────────────
//
// OCR 응답에 splits[] 가 있으면 영수증 1장 = 거래 N개로 분할.
// 같은 sourceReceiptId 공유. 거래장부에서 묶어 표시 가능.

/**
 * 간단한 UUID v4 (외부 라이브러리 X)
 */
export function genReceiptId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  // fallback
  return 'r_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
}

/**
 * 분할 항목 합계 검증 — supply 합이 영수증 supply의 ±5% 안에 들어오는지
 * @returns {{ ok: boolean, sumSupply: number, expectedSupply: number, ratio: number }}
 */
export function validateSplits(splits, expectedTotal) {
  if (!Array.isArray(splits) || splits.length === 0) {
    return { ok: false, reason: 'splits 비어있음' };
  }
  const sumTotal = splits.reduce((s, x) => s + (Number(x.total) || 0), 0);
  if (!expectedTotal) return { ok: true, sumTotal, expectedTotal: null };
  const ratio = sumTotal / expectedTotal;
  return {
    ok: ratio > 0.95 && ratio < 1.05,
    sumTotal,
    expectedTotal,
    ratio,
  };
}

/**
 * 분할 항목 정규화 — 비어있는 카테고리 채우고 supply/vat/total 보정
 */
export function normalizeSplit(split, parentEvidenceType = 'card') {
  const total = Number(split.total) || 0;
  let supply = Number(split.supply) || 0;
  let vat = Number(split.vat) || 0;
  if (supply === 0 && vat === 0 && total > 0) {
    supply = Math.round(total / 1.1);
    vat = total - supply;
  } else if (total === 0 && (supply || vat)) {
    // total 보정
  }
  return {
    itemName: split.itemName || '',
    supply,
    vat,
    total: total || (supply + vat),
    category: split.category || { major: 'etc', sub: 'misc' },
    presumedCandidate: !!split.presumedCandidate,
    presumedReason: split.presumedReason || null,
    evidenceType: parentEvidenceType,
  };
}

/**
 * 새 거래처 객체 빈 템플릿
 */
export function newPartner() {
  return {
    name: '',
    bizNumber: null,               // 사업자번호 (10자리)
    bizType: 'general',
    defaultCategory: null,
    isFrequent: false,
    note: '',
    createdAt: null,
    lastUsedAt: null,
  };
}

// 카테고리 라벨 lookup
export function categoryLabel(major, sub) {
  const M = CATEGORY_MAJOR.find(m => m.id === major);
  if (!M) return Lv('미분류');
  if (!sub) return Lv(M.label);
  const subList = CATEGORY_SUB[major] || [];
  const S = subList.find(s => s.id === sub);
  return S ? `${Lv(M.label)} · ${Lv(S.label)}` : Lv(M.label);   // V160 중국어 화면이면 중국어
}

export function evidenceLabel(typeId) {
  const e = EVIDENCE_TYPES.find(x => x.id === typeId);
  return e ? Lv(e.label) : typeId;
}

export function bizTypeLabel(typeId) {
  const b = BIZ_TYPES.find(x => x.id === typeId);
  return b ? b.label : typeId;
}

// ── 종합소득세 신고 모드 (단순경비율 / 기준경비율 / 간편장부) ────────────────
//
// 종소세 추계신고는 두 가지 — 단순경비율 / 기준경비율
// 기장신고는 두 가지 — 간편장부 / 복식부기
// ddabak V1은 단순경비율, 기준경비율, 간편장부 3가지를 비교한다 (복식부기는 V2).
//
// 각 모드별 소득금액(필요경비를 뺀 사업소득) 계산식:
//
// 1) 단순경비율 추계  (직전수입 < 업종별 한도, 신규사업자는 당해수입 < 복식부기 한도)
//    소득금액 = 수입금액 × (1 - 단순경비율)
//    영수증 증빙 필요 X. 가장 간단. 매출이 작을 때 보통 가장 유리.
//
// 2) 기준경비율 추계  (위 한도 초과 ~ 복식부기 의무 미만 / 또는 단순경비율 적용 못 받는 신규사업자)
//    소득금액 = 수입금액
//             - 매입비용(증빙)
//             - 임차료(증빙)
//             - 인건비(증빙)
//             - (수입금액 × 기준경비율)
//    단, 복식부기 의무자가 추계신고하는 경우 위 결과에 2.8배 추가 (가산)
//    음식점업 한식 (552) 기준경비율은 단순경비율보다 훨씬 낮으므로 보통 불리.
//
// 3) 간편장부 (기장신고)
//    소득금액 = 매출 - 실제 적격증빙 경비 합계
//    영수증 다 증빙 가능하면 가장 정확. 절세 잠재력 ↑.
//    (간편장부 대상자가 복식부기로 작성하면 별도로 기장세액공제 20% 가능)

// 업종코드별 단순경비율·기준경비율 + 기장의무 기준
// 음식점업 위주로 시작. V1.5에서 다른 업종 확장.
export const EXPENSE_RATE_TABLE = {
  '552101': {
    label: '한식 일반음식점',
    industry: 'food',
    simpleRate: 0.897,    // 단순경비율 89.7%
    standardRate: 0.101,  // 기준경비율 10.1%
  },
  '552303': {
    label: '커피전문점·비알코올음료',
    industry: 'food',
    simpleRate: 0.781,
    standardRate: 0.124,
  },
  '930914': {
    label: '미용업',
    industry: 'service',
    simpleRate: 0.665,
    standardRate: 0.215,
  },
  '930915': {
    label: '이용업',
    industry: 'service',
    simpleRate: 0.795,
    standardRate: 0.196,
  },
};

// ⚠️ 정확한 경비율은 매년 국세청 고시(매년 4월경)로 변경됨.
// 사용자에게는 "참고용 추정치"로 표시하고 홈택스 조회 권장.

// 업종별 기장의무·단순경비율 적용 한도 (직전 과세기간 수입금액 기준)
//
// "industry" → 단순경비율 한도 / 간편장부 한도 (= 복식부기 의무 기준)
// 단위: 원
//
// 2024년 이후 단순경비율 한도가 모든 업종 ↑ (예: 음식점업 2,400만 → 3,600만)
// 2025년 귀속(2026 신고)도 동일.
//
// 신규사업자(직전 수입금액 없음)는 당해 수입금액으로 판정한다 — 이 경우
// "복식부기 한도" 미만이면 단순경비율 가능. 단, 의료·전문 일부 업종은 신규여도
// 단순경비율 미적용 (복식부기 강제). 음식점·소매·서비스업은 가능.

export const INDUSTRY_THRESHOLDS = {
  // 농·임·어업, 도매업, 부동산매매업 등
  high: {
    simpleLimit: 60_000_000,        // 직전 수입 6,000만 미만 → 단순경비율
    bookkeepingLimit: 300_000_000,  // 직전 수입 3억 미만 → 간편장부 / 이상 복식부기
  },
  // 제조업, 음식점업, 숙박업, 운수업 등
  medium: {
    simpleLimit: 36_000_000,        // 직전 수입 3,600만 미만 → 단순경비율
    bookkeepingLimit: 150_000_000,  // 직전 수입 1.5억 미만 → 간편장부
  },
  // 부동산 임대, 서비스업, 미용업 등
  low: {
    simpleLimit: 24_000_000,
    bookkeepingLimit: 75_000_000,
  },
};

export function getThresholds(industry) {
  if (industry === 'food' || industry === 'restaurant' || industry === 'manufacturing') {
    return INDUSTRY_THRESHOLDS.medium;
  }
  if (industry === 'wholesale' || industry === 'agriculture') {
    return INDUSTRY_THRESHOLDS.high;
  }
  return INDUSTRY_THRESHOLDS.low;  // 서비스업·미용업 등 default
}

// ── 신고 모드 자동 판정 ────────────────────────────────────────────────────
/**
 * 사업자가 받을 수 있는 신고 모드 결정.
 * @param {object} params
 *   - industryCode: 업종코드 (e.g. '552101')
 *   - prevRevenue: 직전 과세기간 수입금액 (신규사업자면 null)
 *   - currRevenue: 당해 과세기간 수입금액
 * @returns {{ availableModes: string[], required: string, reasons: object }}
 */
export function determineFilingMode({ industryCode, prevRevenue = null, currRevenue = 0 }) {
  const meta = EXPENSE_RATE_TABLE[industryCode];
  if (!meta) {
    return { availableModes: ['simple', 'standard', 'simpleBook'], required: null, reasons: { note: '업종코드 미상' } };
  }
  const th = getThresholds(meta.industry);
  const isNew = prevRevenue === null || prevRevenue === undefined;
  const reasons = {};

  // 신규사업자 케이스
  if (isNew) {
    reasons.newBusiness = true;
    if (currRevenue < th.bookkeepingLimit) {
      // 단순경비율 + 기준경비율 + 간편장부 모두 가능
      reasons.simpleAvailable = `신규사업자 + 당해 수입 ${(th.bookkeepingLimit/100_000_000).toFixed(1)}억 미만`;
      return {
        availableModes: ['simple', 'standard', 'simpleBook'],
        required: null,
        reasons,
      };
    }
    // 신규인데 1.5억 이상 → 단순경비율 X, 기준경비율도 2.8배 가산. 복식부기 권장.
    reasons.bookkeepingRequired = `신규지만 당해 수입 ${(th.bookkeepingLimit/100_000_000).toFixed(1)}억 이상 — 복식부기 강제`;
    return {
      availableModes: ['standard', 'doubleBook'],
      required: 'doubleBook',
      reasons,
    };
  }

  // 기존사업자 — 직전 수입으로 판정
  if (prevRevenue < th.simpleLimit) {
    reasons.simpleAvailable = `직전 수입 ${th.simpleLimit.toLocaleString()}원 미만`;
    return {
      availableModes: ['simple', 'standard', 'simpleBook'],
      required: null,
      reasons,
    };
  }
  if (prevRevenue < th.bookkeepingLimit) {
    reasons.standardOnly = `직전 수입 ${th.simpleLimit.toLocaleString()}~${th.bookkeepingLimit.toLocaleString()}원 — 단순경비율 X`;
    return {
      availableModes: ['standard', 'simpleBook'],
      required: null,
      reasons,
    };
  }
  reasons.doubleRequired = `직전 수입 ${(th.bookkeepingLimit/100_000_000).toFixed(1)}억 이상 — 복식부기 의무`;
  return {
    availableModes: ['doubleBook', 'standard'],
    required: 'doubleBook',
    reasons,
  };
}

// ── 모드별 사업소득금액 계산 ────────────────────────────────────────────────

/** 단순경비율 추계: 소득금액 = 수입금액 × (1 - 단순경비율) */
export function calcSimpleRateIncome({ revenue, industryCode }) {
  const meta = EXPENSE_RATE_TABLE[industryCode];
  if (!meta) return { income: revenue, expense: 0, rate: 0, error: '업종코드 미상' };
  const expense = Math.round(revenue * meta.simpleRate);
  const income = Math.max(0, revenue - expense);
  return { income, expense, rate: meta.simpleRate, label: meta.label };
}

/**
 * 기준경비율 추계: 소득금액 = 수입 - 주요경비(증빙) - 수입×기준경비율
 *   복식부기 의무자 추계신고 시 비교 cap이 따로 적용되는데, 그 처리는
 *   compareFilingModes()에서 단순경비율 × 2.8과 비교해서 작은 값으로 cap한다.
 *   여기선 일반(1배수) 계산만 한다.
 */
export function calcStandardRateIncome({ revenue, industryCode, mainCosts = {} }) {
  const meta = EXPENSE_RATE_TABLE[industryCode];
  if (!meta) return { income: revenue, expense: 0, rate: 0, error: '업종코드 미상' };
  const purchase = Number(mainCosts.purchase) || 0;
  const rent = Number(mainCosts.rent) || 0;
  const labor = Number(mainCosts.labor) || 0;
  const mainTotal = purchase + rent + labor;
  const standardExpense = Math.round(revenue * meta.standardRate);
  const income = Math.max(0, revenue - mainTotal - standardExpense);
  return {
    income,
    expense: mainTotal + standardExpense,
    mainCostsTotal: mainTotal,
    standardExpense,
    rate: meta.standardRate,
    label: meta.label,
    breakdown: { purchase, rent, labor, standardExpense },
  };
}

/** 간편장부: 소득금액 = 수입 - 실제 경비 (모든 적격증빙) */
export function calcSimpleBookIncome({ revenue, totalExpense }) {
  const income = Math.max(0, revenue - (totalExpense || 0));
  return { income, expense: totalExpense || 0 };
}

/**
 * 3가지 모드 동시 계산 + 가장 유리한 모드 추천
 * @returns 객체 { simple, standard, simpleBook, recommendation: { mode, reason, savings } }
 */
export function compareFilingModes({
  industryCode,
  revenue,
  mainCosts = {},
  totalExpense = 0,
  isDoubleBookRequired = false,
}) {
  const simple = calcSimpleRateIncome({ revenue, industryCode });
  const standard = calcStandardRateIncome({ revenue, industryCode, mainCosts });
  const simpleBook = calcSimpleBookIncome({ revenue, totalExpense });

  // 복식부기 의무자가 추계신고를 하는 경우 기준경비율 추계 소득은
  // MIN[ 위 결과, 단순경비율 추계 소득 × 2.8 ] 로 cap 된다.
  // (소득세법 시행령 §143). 신규사업자는 해당 없음.
  if (isDoubleBookRequired) {
    const simpleX28 = Math.round(simple.income * 2.8);
    if (simpleX28 < standard.income) {
      standard.income = simpleX28;
      standard.cappedBySimple = true;
    }
  }

  // 가장 유리한 모드 = 소득금액 가장 작은 것
  const candidates = [
    { mode: 'simple',     label: '단순경비율',  income: simple.income },
    { mode: 'standard',   label: '기준경비율',  income: standard.income },
    { mode: 'simpleBook', label: '간편장부',    income: simpleBook.income },
  ].filter(c => c.income !== null && c.income !== undefined);

  candidates.sort((a, b) => a.income - b.income);
  const winner = candidates[0];
  const runnerUp = candidates[1];
  const savings = runnerUp ? Math.max(0, runnerUp.income - winner.income) : 0;

  return {
    simple, standard, simpleBook,
    recommendation: {
      mode: winner.mode,
      label: winner.label,
      income: winner.income,
      runnerUp: runnerUp ? runnerUp.label : null,
      savings,
      strong: savings > 1_000_000,
    },
  };
}

export function calcYouthStartupCredit({ baseTax, region = 'non_capital', startedYear = null }) {
  if (!baseTax || baseTax <= 0) return { credit: 0, rate: 0, note: '산출세액 없음' };
  const before2026 = startedYear !== null && startedYear < 2026;
  let rate = 0;
  if (before2026) {
    if (region === 'capital_overcrowded') rate = 0.5;
    else rate = 1.0;
  } else {
    if (region === 'capital_overcrowded') rate = 0.5;
    else if (region === 'capital_general') rate = 0.75;
    else rate = 1.0;
  }
  const credit = Math.round(baseTax * rate);
  return { credit, rate, note: `${(rate*100).toFixed(0)}% 감면` };
}

export function calcBookkeepingCredit({ baseTax, businessIncome, totalIncome }) {
  if (!baseTax || baseTax <= 0) return { credit: 0 };
  if (!totalIncome || totalIncome <= 0) return { credit: 0 };
  const ratio = (businessIncome || 0) / totalIncome;
  const raw = Math.round(baseTax * ratio * 0.2);
  return { credit: Math.min(1_000_000, raw), ratio };
}
